import debounce from './debounce.js'

export default debounce(function () {
    // Check for lazyload adverts on page.
  if ($('.advertisement--lazyload').length) {
    // Deal with advertisements that are now hidden.
      // Destroy/Empty advert placeholder divs that are now or have always been hidden.
      // If any ads are hidden when the call to populate them is called we will get an error.
    $('.advertisement--lazyload:hidden').html('')
      // Mark ALL the :hidden advertisement placeholders with an 'empty' class so we know which may need to be reviewed next time.
    $('.advertisement--lazyload:hidden').addClass('advertisement--lazyload--empty')

    // Deal with advertisements that are now showing.
      // Check for 'empty' lazyload adverts.
    if ($('.advertisement--lazyload--empty:visible').length) {
      // For placeholder divs that ane now visible but are also empty (leave alone adverts that are already showing).
      // Fill the placeholder divs with the HTML for the.
      $('.advertisement--lazyload--empty:visible').html('<ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-7401091822721150" data-ad-slot="1761601644" data-ad-format="auto"></ins>')
      // These previously empty ads should now be full so remove the 'empty' class.
      // Mark these newly filled placeholders that the ad loading script should be fired
      $('.advertisement--lazyload--empty:visible').removeClass('advertisement--lazyload--empty').addClass('advertisement--lazyload--tofire')
    }

    // Only fire ads load if there are some visible ads on page
    // Only fire once each for those ads that are currently empty
    if ($('.advertisement--lazyload--tofire').length) {
      // The load ad script seems to need to be run once per ad so run it once per ad placeholder
      for (let i = 0; i < $('.advertisement--lazyload--tofire').length; i++) {
        (adsbygoogle = window.adsbygoogle || []).push({})
      }

      $('.advertisement--lazyload--tofire').removeClass('advertisement--lazyload--tofire')
    }
  }
}, 250)

// window.addEventListener('resize', myEfficientFn)
